import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ModalSwitchLabel = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
}));

export const SwitchWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  paddingBottom: 24,
  marginLeft: "-8px",
}));

const styles = makeStyles(() => ({
  modalWrapper: {
    width: "442px !important",
  },
}));

export default styles;
